import { Segmented, message, Popover } from "antd";
import { useEffect, useMemo, useState, useContext, useRef } from "react"
import API from '@api/api'
import Utils from '@utils/utils'
import styles from './index.module.scss'
import markIcon from '@assets/images/svgIcon/markIcon.svg'
import { LeftOutlined, RightOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import eventBus from "@utils/eventBus"
import { AppContext } from '@utils/AppContext';
import { SELECT_ORG_TYPE } from '@utils/CONST';
import Iconfont from '@utils/Iconfont';


const beanIcon = require('@assets/images/arcbean3.png')
const modelCustomizationQrcode = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/qrcode_sales.png?t=29746785'

const isModelCustomizationPlan = (item) => (
    item?.name === '模特定制'
    || item?.description === '模特定制'
)

const formatConvertInfo = (convertText = '') => {
    const normalizedText = String(convertText).replace(/\s/g, '')
    const matched = normalizedText.match(/^([\d,]+)虹豆(?:（?1虹豆≈([0-9.]+)）?)?$/)

    if (!matched) {
        return {
            amount: convertText,
            unitPrice: '',
        }
    }

    return {
        amount: matched[1],
        unitPrice: matched[2] || '',
    }
}

const formatPriceDisplay = (price) => {
    const numericPrice = Number(price)

    if (Number.isNaN(numericPrice)) return price

    return numericPrice.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}

const getPersonalImgCountDisplay = (item) => {
    if (item.unit === 'Year' && item.level === 'ultra') {
        return '1.9万'
    }

    return item.imgCount
}

const formatNumberWithCommas = (value) => {
    const numericValue = Number(String(value).replace(/,/g, ''))

    if (Number.isNaN(numericValue)) return value

    return numericValue.toLocaleString('en-US')
}

const highlightPowerText = (text = '') => {
    const patterns = [
        { match: '支持2台设备同时在线', prefix: '2台' },
        { match: '支持4台设备同时在线', prefix: '4台' },
        { match: '支持6台设备同时在线', prefix: '6台' },
        { match: '专属1v1客服支持', prefix: '1v1客服' },
        { match: '专属技术顾问', prefix: '技术顾问' },
        { match: '高优先级', prefix: '高' },
        { match: '最高优先级', prefix: '最高' },
    ]

    const matchedPattern = patterns.find((item) => item.match === text)

    if (!matchedPattern) return text

    const startIndex = text.indexOf(matchedPattern.prefix)
    const beforeText = text.slice(0, startIndex)
    const afterText = text.slice(startIndex + matchedPattern.prefix.length)

    return (
        <>
            {beforeText}
            <span className={styles.powerHighlight}>{matchedPattern.prefix}</span>
            {afterText}
        </>
    )
}


const options = [
    { label: '个人月卡', value: 0 },
    { label: '个人年卡', value: 1 },
    { label: <span className={styles.batchImagesTag}>企业套餐</span>, value: 2 },
    { label: '模特定制', value: 3 },
]
const options2 = [
    { label: <span className={styles.batchImagesTag}>企业套餐</span>, value: 2 },
    { label: '模特定制', value: 3 },
]

const MemberPackage = (props) => {
    const { globalUser, globalOrgInfo, setPayOrderInfo, payOrderInfo, isAutoRenew, setIsAutoRenew } = useContext(AppContext);
    const [type, setType] = useState(globalOrgInfo?.current?.id ? 2 : 0)
    const [modelCustomizationPlan, setModelCustomizationPlan] = useState(null)
    const [modelCustomizationNum, setModelCustomizationNum] = useState(1)
    const [plansList, setPlansList] = useState([{
        level: "basic",
        currentLevel: 1,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        discountPrice: '48',
        convert: '1,000虹豆 （1虹豆≈0.048）',
        imgCount: 100,
        singlePrice: 0.48,
        unit: "Month",
        powerList: ['每日登录赠送积分'],
        monthlySubscription: true, // 连续包月
        subscriptionPrice: '42',
    }, {
        level: "pro",
        currentLevel: 2,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '5,000虹豆 （1虹豆≈0.037）',
        imgCount: 500,
        singlePrice: 0.48,
        unit: "Month",
        powerList: ['每日登录赠送积分', '支持2台设备同时在线']
    }, {
        level: "max",
        currentLevel: 3,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '20,000虹豆 （1虹豆≈0.024）',
        imgCount: 2000,
        singlePrice: 0.48,
        selected: true,
        unit: "Month",
        powerList: ['每日登录赠送积分', '支持4台设备同时在线', '专属1v1客服支持']
    }, {
        level: "ultra",
        currentLevel: 4,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '40,000虹豆 （1虹豆≈0.022）',
        imgCount: 4000,
        singlePrice: 0.48,
        unit: "Month",
        powerList: ['每日登录赠送积分', '支持6台设备同时在线', '专属1v1客服支持']
    }])

    useEffect(() => {
        if (globalOrgInfo?.current?.id && type !== 2 && type !== 3) {
            setType(2)
        }
    }, [globalOrgInfo?.current?.id, type])

    const [yearPlansList, setYearPlansList] = useState([{
        level: "max",
        currentLevel: 3,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '20,000虹豆 （1虹豆≈0.024）',
        imgCount: 2000,
        singlePrice: 0.48,
        unit: "Year",
        powerList: ['每日登录赠送积分', '支持4台设备同时在线', '专属1v1客服支持']
    }, {
        level: "ultra",
        currentLevel: 4,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '40,000虹豆 （1虹豆≈0.022）',
        imgCount: 4000,
        singlePrice: 0.48,
        unit: "Year",
        powerList: ['每日登录赠送积分', '支持6台设备同时在线', '专属1v1客服支持']
    }])

    const [teamPlansList, setTeamPlansList] = useState([{
        level: "team",
        currentLevel: 5,
        title: 'PSAI 企业版 Pro',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        convert: '1虹豆≈0.026',
        unit: "Year",
        customize: 2,
        powerList: ['高品质生成', '优先出图权益', '线上培训', '专属客服']
    }, {
        level: "teamBasic",
        selected: true,
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 3,
        discount: [9, '.2折'],
        powerList: ['高品质生成', '优先出图权益', '线上培训', '专属客服', '品类专项训练']
    }, {
        level: "teamPro",
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 5,
        discount: [8, '.5折'],
        powerList: ['高品质生成', '优先出图权益', '线上培训', '专属客服', '品类专项训练', '联合营销机会']
    }, {
        level: "teamMax",
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 10,
        discount: [7, '.8折'],
        powerList: ['高品质生成', '高优先级', '线上培训', '专属技术顾问', '品类专项训练', '联合营销机会', '线下沙龙']
    }, {
        level: "teamUltra",
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 20,
        discount: [7, '.1折'],
        powerList: ['高品质生成', '最高优先级', '线上培训', '专属技术顾问', '品类专项训练', '联合营销机会', '线下沙龙']
    }])


    const onPayedClick = (id, currentLevel, level, monthlySubscription, num = 1, isModelCustomization = false) => {
        const status = Utils.checkLoginStatus(() => onPayedClickFun(id, currentLevel, level, monthlySubscription, num, isModelCustomization))
        if (!status) return
        onPayedClickFun(id, currentLevel, level, monthlySubscription, num, isModelCustomization)
    }

    const onPayedClickFun = (id, currentLevel, level, monthlySubscription, num = 1, isModelCustomization = false) => {
        setPayOrderInfo({
            ...payOrderInfo,
            skuId: id,
            orgId: globalOrgInfo?.current.id,
            monthlySubscription,
            num,
            isModelCustomization,
        })

        setTimeout(() => {
            if (globalOrgInfo?.isPersonal && (currentLevel == 5 || currentLevel == 6) && globalOrgInfo?.orgList.length > 1) {
                // 个人用户购买企业套餐且有多个企业时，打开选择企业弹窗
                eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.BUYORG })
            } else {
                // 其他情况下直接发起支付
                eventBus.emit('pc_pay')
            }
        }, 30)
    }

    const getListPlan = () => {
        API.getListPlan({}).then((res) => {
            if (res.code == 0) {
                const updatedPlansList = [...plansList];
                const updatedYearPlansList = [...yearPlansList];
                const updatedTeamYearPlansList = [...teamPlansList];
                let nextModelCustomizationPlan = null;

                res.data.forEach(item => {
                    if (isModelCustomizationPlan(item)) {
                        nextModelCustomizationPlan = item;
                        return;
                    }

                    const planIndex = updatedPlansList.findIndex(plan => plan.level === item.level && plan.unit === item.unit);
                    const yearPlanIndex = updatedYearPlansList.findIndex(plan => plan.level === item.level && plan.unit === item.unit);
                    const teamYearPlanIndex = updatedTeamYearPlansList.findIndex(plan => plan.level === item.level && plan.unit === item.unit);

                    if (planIndex !== -1) {
                        updatedPlansList[planIndex].zhTitle = item.description;
                        updatedPlansList[planIndex].id = item.id;
                        updatedPlansList[planIndex].enTitle = item.name;
                        updatedPlansList[planIndex].price = globalUser?.payedUser === 0 ? item.firstBuyPrice : item.price;
                        updatedPlansList[planIndex].imgCount = item.powerAmount / 10;
                        updatedPlansList[planIndex].singlePrice = (globalUser?.payedUser === 0 && item.firstBuyPrice == 19.9) ? 0.199 : Math.ceil(item.uPrice) / 100;
                        updatedPlansList[planIndex].convert = `${item.powerAmount}虹豆 （1虹豆≈${(globalUser?.payedUser === 0 && item.firstBuyPrice == 19.9) ? 0.0199 : Math.ceil(item.uPrice) / 1000}）`
                    }
                    if (yearPlanIndex !== -1) {
                        updatedYearPlansList[yearPlanIndex].zhTitle = item.description;
                        updatedYearPlansList[yearPlanIndex].id = item.id;
                        updatedYearPlansList[yearPlanIndex].enTitle = item.name;
                        updatedYearPlansList[yearPlanIndex].price = globalUser?.payedUser === 0 ? item.firstBuyPrice : item.price;
                        updatedYearPlansList[yearPlanIndex].imgCount = item.powerAmount / 10;
                        updatedYearPlansList[yearPlanIndex].singlePrice = Math.ceil(item.uPrice) / 100;
                        updatedYearPlansList[yearPlanIndex].convert = `${item.powerAmount}虹豆 （1虹豆≈${Math.ceil(item.uPrice) / 1000}）`
                    }
                    if (teamYearPlanIndex !== -1) {
                        updatedTeamYearPlansList[teamYearPlanIndex].zhTitle = item.description;
                        updatedTeamYearPlansList[teamYearPlanIndex].id = item.id;
                        updatedTeamYearPlansList[teamYearPlanIndex].enTitle = item.name.substring(0, item.name.lastIndexOf(" "));
                        updatedTeamYearPlansList[teamYearPlanIndex].price = globalUser?.payedUser === 0 ? item.firstBuyPrice : item.price;
                        updatedTeamYearPlansList[teamYearPlanIndex].imgCount = item.powerAmount / 10;
                        updatedTeamYearPlansList[teamYearPlanIndex].singlePrice = Math.ceil(item.uPrice) / 100;
                        updatedTeamYearPlansList[teamYearPlanIndex].powerAmount = item.powerAmount;
                        updatedTeamYearPlansList[teamYearPlanIndex].supportMembers = item.supportMembers;
                        updatedTeamYearPlansList[teamYearPlanIndex].concurrentSku = item.concurrentSku;
                    }
                });

                setPlansList(updatedPlansList);
                setYearPlansList(updatedYearPlansList);
                setTeamPlansList(updatedTeamYearPlansList);
                setModelCustomizationPlan(nextModelCustomizationPlan);
            }
        })
    }

    useEffect(() => {
        getListPlan()
    }, [])

    useEffect(() => {
        const teamMax = yearPlansList.find(item => item.config);
        if (!teamMax) return;
        setPayOrderInfo({
            ...payOrderInfo,
            diyPower: teamMax.beanCount,
            diyMember: teamMax.accountCount,
        })
    }, [yearPlansList.find(item => item.config)?.beanCount, yearPlansList.find(item => item.config)?.accountCount]);

    const validityDay = useMemo(() => {
        const today = new Date();
        const future = new Date(today);
        const t = Number(type);

        if (t === 0) {
            future.setDate(today.getDate() + 30);
        } else if (t === 1 || t === 2) {
            future.setDate(today.getDate() + 365);
        }

        const year = future.getFullYear();
        const month = String(future.getMonth() + 1).padStart(2, '0');
        const day = String(future.getDate()).padStart(2, '0');
        return `${year}年${month}月${day}日`;
    }, [type]);


    const personalItem = (item, index) => {
        const convertInfo = formatConvertInfo(item.convert)

        return (
            <div
                onClick={() => onPayedClick(item.id, item.currentLevel, item.level, item.monthlySubscription)}
                className={`${styles.planItem} ${item.selected ? styles.planItemSelected : ''}`}
                key={index}>
                <p className={styles.zhTitle}>{item.enTitle}</p>
                <p className={styles.enTitle}>{item.zhTitle}</p>
                {item.monthlySubscription &&
                    <p className={styles.monthlySubscription}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsAutoRenew(!isAutoRenew);
                        }}>
                        {isAutoRenew ? '连续包月' : '单月购买'} <Iconfont type="icon-changeOutlined" className={styles.Icon} />
                    </p>
                }
                {
                    (item.discountPrice && globalUser?.payedUser === 0) ?
                        <p className={styles.price2}>
                            <span style={{ textDecoration: 'line-through' }}>{item.discountPrice}</span>&nbsp;
                            <span>
                                <span style={{ fontSize: '12px', }}> ¥ </span>
                                <span style={{ color: '#FF4949' }}>{item.unit == "Year" ? formatPriceDisplay(item.price) : item.price}</span>
                                <span style={{ fontSize: '12px' }}> / {item.unit == "Year" ? '年' : '月'}</span>
                            </span>
                        </p> :
                        (item.monthlySubscription && !isAutoRenew) ?
                            <>
                                <p className={styles.price2}>
                                    <span style={{ textDecoration: 'line-through' }}>{item.price}</span>&nbsp;
                                    <span>
                                        <span style={{ fontSize: '12px' }}> ¥ </span>
                                        <span style={{ color: '#FF4949' }}>{item.subscriptionPrice}</span>
                                        <span style={{ fontSize: '12px' }}> / 月</span>
                                    </span>
                                </p>
                                <p className={styles.subscriptionDesc}>首购优惠<span className={styles.subscriptionPriceText}> ¥19.9 </span>,到期后按<span className={styles.subscriptionPriceText}> ¥42 </span>自动续费，包月可随时取消</p>
                            </> :
                            <p className={styles.price}>
                                <span>¥<span>{item.unit == "Year" ? formatPriceDisplay(item.price) : item.price}</span> / {item.unit == "Year" ? '年' : '月'}</span>
                            </p>
                }

                <div className={styles.priceInfoBlock}>
                    <p className={styles.convert}>
                        <img className={styles.convertIcon} src={beanIcon} alt="" />
                        <span className={styles.convertValue}>{formatNumberWithCommas(convertInfo.amount)}</span>
                        <span className={styles.convertUnit}>虹豆</span>
                        {convertInfo.unitPrice ? <span className={styles.convertDesc}><span className={styles.convertApprox}>≈</span>{convertInfo.unitPrice} / 虹豆</span> : null}
                    </p>
                    <p className={styles.imgCount}>最多可生成 <span>{getPersonalImgCountDisplay(item)}张</span> 图片</p>
                    <p className={styles.singlePrice}>单张图片价格低至 <span>{item.singlePrice}元</span></p>
                </div>
                <div className={`${styles.buyBtn} ${item.selected ? styles.selected : ''}`}>
                    {item.monthlySubscription && !isAutoRenew ? '立即购买' : '立即购买'}
                </div>
                <div className={styles.powerList}>
                    {item.powerList.map((power, index) => (
                        <p key={index}><img src={markIcon} alt="" />{highlightPowerText(power)}</p>
                    ))}
                </div>
            </div>
        )
    }
    const teamItem = (item, index) => (
        <div
            onClick={() => onPayedClick(item.id, item.currentLevel, item.level)}
            className={`${styles.planItem} ${item.selected ? styles.planItemSelected : ''}`}
            key={index}>
            <p className={styles.zhTitle}>{item.enTitle}</p>
            <p className={`${styles.enTitle} ${styles[`enTitle${index}`]}`}>
                {item.zhTitle}
                {
                    item.discount && <span className={styles.enTitleIcon}><span>{item.discount?.[0]}</span>{item.discount?.[1]}</span>
                }
            </p>
            <p className={styles.price}>
                <span>¥<span>{formatPriceDisplay(item.price)}</span> /{item.unit == "Year" ? '年' : '月'}</span>
            </p>
            <p className={`${styles.convert} ${styles.teamConvert}`}>≈{Number(item.price / 12).toFixed(2)}/每月</p>
            <div className={styles.teamInfoBlock}>
                <p className={styles.teamPowerAmount}>
                    <img className={styles.teamPowerIcon} src={beanIcon} alt="" />
                    <span>{formatNumberWithCommas(item.powerAmount)}</span> 虹豆，<span>{item.supportMembers == -1 ? '无限' : item.supportMembers}</span> 席位
                </p>
                <p className={styles.tips}>最多可生成 <span>{item.powerAmount / 100000}万张</span> 图片，单图约 <span>{item.singlePrice.toFixed(2)}元</span></p>
                <p className={styles.tips}>可同时上传 <span>{item.concurrentSku}个</span> 素材</p>
                <p className={styles.customize}>首次购买加赠 <span>{item.customize}</span> 个企业定制模特
                    <Popover
                        placement="top"
                        content={
                            <>
                                <img
                                    style={{ width: '120px', height: '120px' }}
                                    src={Utils.qrcodeSales}
                                    alt="扫码联系我们"
                                />
                                <p style={{ textAlign: 'center', marginTop: '8px' }}>添加客服微信领取</p>
                                <p style={{ textAlign: 'center', color: '#96A2B1', fontSize: '12px' }}>*仅首次购买该套餐可享</p>
                            </>
                        }
                    >
                        <ExclamationCircleOutlined style={{ marginLeft: '8px', color: '#000812' }} />
                    </Popover>
                </p>
            </div>
            <div className={`${styles.buyBtn} ${item.selected ? styles.selected : ''}`} style={{ margin: '12px 0' }} >立即购买</div>
            <div className={styles.powerList} style={{ marginTop: 0 }}>
                {item.powerList.map((power, index) => (
                    <p key={index}><img src={markIcon} alt="" />{highlightPowerText(power)}</p>
                ))}
            </div>
        </div>
    )

    const modelCustomizationPrice = useMemo(() => {
        const price = modelCustomizationPlan?.discountPrice
            ?? modelCustomizationPlan?.firstBuyPrice
            ?? modelCustomizationPlan?.price
        const numericPrice = Number(price)

        if (!Number.isFinite(numericPrice)) return '--'
        return String(numericPrice * modelCustomizationNum)
    }, [modelCustomizationPlan, modelCustomizationNum])

    const handleModelCustomizationBuy = () => {
        if (!modelCustomizationPlan?.id) {
            message.warning('套餐加载中，请稍后重试')
            return
        }

        onPayedClick(
            modelCustomizationPlan.id,
            modelCustomizationPlan.currentLevel,
            modelCustomizationPlan.level,
            false,
            modelCustomizationNum,
            true,
        )
    }

    const modelCustomizationContent = (
        <div className={styles.modelCustomizationCard}>
            <div className={styles.modelCustomizationMain}>
                <div className={styles.modelCustomizationTitleRow}>
                    <h3>专属模特定制</h3>
                    <p className={styles.modelCustomizationPrice}>
                        <span className={styles.modelCustomizationCurrency}>¥</span>
                        <span>{modelCustomizationPrice}</span>
                        <span className={styles.modelCustomizationUnit}>/个</span>
                    </p>
                </div>
                <p className={styles.modelCustomizationDesc}>定制企业专属AI模特形象</p>
                <div className={styles.modelCustomizationStepper}>
                    <button
                        type="button"
                        disabled={modelCustomizationNum <= 1}
                        onClick={() => setModelCustomizationNum((prev) => Math.max(1, prev - 1))}
                    >
                        −
                    </button>
                    <span>{modelCustomizationNum}</span>
                    <button
                        type="button"
                        disabled={modelCustomizationNum >= 10}
                        onClick={() => setModelCustomizationNum((prev) => Math.min(10, prev + 1))}
                    >
                        +
                    </button>
                </div>
                <button
                    type="button"
                    className={styles.modelCustomizationBuy}
                    onClick={handleModelCustomizationBuy}
                >
                    立即购买
                </button>
            </div>
            <div className={styles.modelCustomizationDivider} />
            <div className={styles.modelCustomizationService}>
                <img src={modelCustomizationQrcode} alt="详情请咨询客服" />
                <p>详情请咨询客服</p>
            </div>
        </div>
    )


    // 滚动按钮
    const scrollRef = useRef(null)
    const [position, setPosition] = useState('left')
    const handleScrollRight = () => {
        setPosition('right')
        const box = scrollRef.current
        box.scrollTo({
            left: box.scrollWidth,
            behavior: 'smooth'
        })
    }
    const handleScrollLeft = () => {
        setPosition('left')
        const box = scrollRef.current
        box.scrollTo({
            left: 0,
            behavior: 'smooth'
        })
    }


    return (
        <div className={styles.MemberPackage}>
            <Segmented
                className={globalOrgInfo?.current?.id ? `${styles.Segmented} ${styles.Segmented2}` : styles.Segmented}
                value={type}
                options={globalOrgInfo?.current?.id ? options2 : options}
                onChange={(value) => { setType(value); setPosition('left') }} />

            <div className={styles.planList}>
                {
                    type === 0 ? plansList.map((item, index) => (
                        personalItem(item, index)
                    )) : type === 1 ? <div style={{ width: '624px', display: 'flex', justifyContent: 'space-between', margin: '0 auto' }}>
                        {
                            yearPlansList.map((item, index) => (
                                personalItem(item, index)
                            ))
                        }
                    </div>
                        : type === 2 ? <div className={styles.carouselWrapper}>
                            {position != 'left' && <div className={styles.leftBtn} onClick={handleScrollLeft}><LeftOutlined /></div>}
                            {position != 'left' && <div className={styles.leftShadow}></div>}
                            <div className={styles.carousel} ref={scrollRef}>
                                <div className={styles.carouselWrapperBox}>
                                    {teamPlansList.map((item, index) => teamItem(item, index))}
                                </div>
                            </div>
                            {position != 'right' && <div className={styles.rightShadow}></div>}
                            {position != 'right' && <div className={styles.rightBtn} onClick={handleScrollRight}><RightOutlined /></div>}
                        </div> :
                            <div className={styles.modelCustomizationWrapper}>
                                {modelCustomizationContent}
                            </div>
                }
            </div>
            <p className={`${styles.planValidity} ${type === 3 ? styles.planValidityHidden : ''}`}>
                会员方案有效期为{type === 0 ? '30天' : '365天'}，现在购买有效期至{validityDay}
            </p>
        </div>
    )
}

export default MemberPackage
